import { AsyncState, useAsync } from 'react-async';
import { AsyncErrorHandling } from '../../../common/async';
import { TeamModel } from '../models/team-model';
import * as teamService from '../team-service';
import { useParams } from 'react-router';
import { ReactNode } from 'react';

const getTeam = ({ id }) => teamService.getTeam(id);

export interface FetchTeamProps {
    children: (team: TeamModel, state: AsyncState<TeamModel>) => ReactNode;
}

export const FetchTeam = ({ children }: FetchTeamProps) => {
    const { teamId } = useParams();
    const state = useAsync(getTeam, { id: teamId });

    if (state.error != null) {
        return <AsyncErrorHandling error={state.error} />;
    }
    if (state.data == null) {
        return <></>;
    }

    return <>{children(state.data, state)}</>;
};

export default FetchTeam;
